<template>
  <div id="defaultId1" class=" defBord  ">
    <el-dialog id="idpfCClW" class=" defBord  " :title="$t('添加分类')" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-tabs style="margin-left: 50px" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="tab in translations" :key="tab.text" :label="tab.text" :name="tab.name">
          <span slot="label">{{tab.text}}<i v-if="tab.translated" class="el-icon-success" style="color: #67C23A"></i></span>
        </el-tab-pane>
      </el-tabs>
      <el-form id="idez97UO" class="defBord" size="small" style="width: 70%;margin: 20px auto" :model="translations[activeName].form" :rules="formRules" ref="form">
        <el-form-item id="id1RddrE" class=" defBord  " :label="$t('分类名称')" prop="name" :label-width="formLabelWidth">
          <el-input v-model="translations[activeName].form.name" @blur="translateLanguage()" autocomplete="off" style="width: 60%"></el-input>
          <mi-free-time :styles="{left:'60px',top:'5px'}">
            <el-button size="small" type="warning" @click="translateLanguage()" :loading="translateLoading">{{$t('翻译')}}</el-button>
          </mi-free-time>
        </el-form-item>
        <el-form-item id="idVViJLx" class=" defBord  " :label="$t('分类排序')" prop="sort" :label-width="formLabelWidth">
          <el-input id="idg6Thvg" @blur="catSortData()" style="width: 60%" class="defBord" v-model.number="translations[activeName].form.sort" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item id="idNSriIE" class=" defBord  " :label="$t('分类图片')" :label-width="formLabelWidth">
          <el-row id="idnlfM54" class=" defBord  ">
            <el-button id="idGWbK3d" @click="openUpload" class="defBord" type="primary">{{$t('选择图片')}}
            </el-button>
            <div id="idFFTxOC" class="defBord  img" v-if="translations[activeName].form.image_id!=''">
              <img id="idLEGbLn" class="defBord" :src="file_path" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item>
      </el-form>
      <div id="idtx1un1" class="dialog-footer defBord  " slot="footer">
        <el-button id="idXjhGlW" @click="dialogFormVisible" class=" defBord  ">{{$t('取 消')}}
        </el-button>
        <el-button id="idhLvrdc" @click="addUser" class=" defBord  " type="primary" :loading="loading">{{$t('确 定')}}
        </el-button>
      </div>
      <!-- 上传图片组件 -->
      <Upload id="idDZCvck" class=" defBord  " v-if="isupload" :isupload="isupload" :type="type" :isAspectRatio="false"  @returnImgs="returnImgsFunc">{{$t('上传图片')}}
      </Upload>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    Upload
  },
  data() {
    return {
      translations: {
        chinese: { text: '中文', translated: false, name:'chinese', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        english: { text: 'English', translated: false, name:'english', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        italian: { text: 'Italiano', translated: false, name:'italian', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        german: { text: 'Deutsch', translated: false, name:'german', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        spanish: { text: 'Español', translated: false, name:'spanish', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        french: { text: 'Français', translated: false, name:'french', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        croatia: { text: 'Hrvatska', translated: false, name:'croatia', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        slovenia: { text: 'Slovenščina', translated: false, name:'slovenia', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
        hungarian: { text: 'Magyar', translated: false, name:'hungarian', form: {
            "parent_id": "0",
            "name": "",
            "sort": 100,
            "image_id": ""
          } },
      },
      translateLoading:false,
      activeName:localStorage.getItem("mainLanguage"),
      dialogVisible: false,
      file_path:"",
      formRules: {
        "name": [{
          "required": true,
          "message":  this.$t('请输入分类名称'),
          "trigger": "blur"
        }],
        "sort": [{
          "required": true,
          "message":  this.$t('分类排序不能为空')
        }, {
          "type": "number",
          "message": this.$t('分类排序必须为数字')
        }]
      },
      formLabelWidth: '120px',
      loading: false,
      isupload: false
    };
  },
  props: ['open_add', 'addform'],
  created() {
    this.dialogVisible = this.open_add;
  },
  watch:{

  },
  mounted() {},
  methods: {
    //分类数据
    catSortData() {
      for (let key in this.translations){
        if(this.activeName != key){
          this.translations[key].form.sort = this.translations[this.activeName].form.sort
        }
      }
    },
    /*标签页切换*/
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    async translateLanguage(){
      //先判断主语言和当前页面中的语言是否一致，只允许在主语言下的表单进行操作
      let self = this
      let mainLanguage = localStorage.getItem("mainLanguage")
      let word = this.translations[mainLanguage].form.name;
      if (mainLanguage == this.activeName){
        if(!this.translations[mainLanguage].form.name){
          return
        }
        let languageList = Object.keys(this.translations).filter(key => key !== mainLanguage);
        console.log('languageList',languageList)
        await this.requestServerTranslate(word,mainLanguage,languageList)
        this.translateLoading = false
      }
    },
    async requestServerTranslate(word,mainLanguage,languageList){
      let translateData = {
        "word": word,
        "from_language": mainLanguage,
        "languages":languageList,
      }
      this.translateLoading = true
      let res = await PorductApi.translate_words(translateData, true)
      if(res.code == 1){
        let translatedRes = res.data.response
        //拿到大模型返回的翻译数据
        console.log("翻译菜品名称返回来的数据",translatedRes)
        for (let key in translatedRes){
          this.translations[key].form.name = translatedRes[key]
          this.translations[key].translated = true
        }
      }
    },
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    addUser() {
      let self = this;
      if(this.translateLoading){
        self.$message({
          message:self.$t('正在翻译，请稍后') ,
          type: 'warning'
        });
        return
      }
      let params = this.translations[localStorage.getItem("mainLanguage")].form;
      params.category_lang = JSON.stringify({
        "chinese":this.translations.chinese.form.name,
        "english":this.translations.english.form.name,
        "italian":this.translations.italian.form.name,
        "german":this.translations.german.form.name,
        "spanish":this.translations.spanish.form.name,
        "french":this.translations.french.form.name,
        "croatia":this.translations.croatia.form.name,
        "slovenia":this.translations.slovenia.form.name,
        "hungarian":this.translations.hungarian.form.name,
      })
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          PorductApi.storeCatAdd(params).then(data => {
            self.loading = false;
            self.$message({
              message:self.$t('添加成功') ,
              type: 'success'
            });
            self.dialogFormVisible(true);
          }).catch(error => {
            self.loading = false;
          });
        }
      });
    },
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.file_path = e[0].file_path;
        for (let key in this.translations){
          this.translations[key].form.image_id = e[0].file_id
        }
      }
      this.isupload = false;
    }
  },
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/rate/Add.vue